// extracted by mini-css-extract-plugin
module.exports = {"linkRoot":"_372Fj","codeInput":"Z4FHI","error":"_813pW","buttonCode":"_1T__5","footer":"xcvG_","formContent":"_3oHHN","simpleCodeInputSubtitle":"_2nvqt"};